<template>
  <component
    :is="'script'"
    src="//widgets.trustedshops.com/js/XEF59CE5FE17E3A7408CC636FE75953CE.js"
    async
    ata-desktop-y-offset="0" 
    data-mobile-y-offset="0" 
    data-desktop-disable-reviews="false" 
    data-desktop-enable-custom="false" 
    data-desktop-position="left" 
    data-desktop-custom-width="156" 
    data-desktop-enable-fadeout="false" 
    data-disable-mobile="false" 
    data-disable-trustbadge="false" 
    data-mobile-custom-width="156" 
    data-mobile-disable-reviews="false" 
    data-mobile-enable-custom="false" 
    data-mobile-position="left" 
    data-mobile-enable-topbar="false" 
    data-mobile-enable-fadeout="true" 
    charset="UTF-8" 
  />
</template>
